module.exports = __webpack_public_path__ + "img/faq_simple.8afb3103.png";